import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';

import SignUp from 'modules/auth/containers/SignUp';
import Landing from 'modules/auth/containers/Landing';
import PageNotFound from 'partial/containers/PageNotFound';
import ForgotPassword from 'modules/auth/containers/ForgotPassword';
import ExpiredForgotPassword from 'modules/auth/containers/ExpiredForgotPassword';

function Public() {
  return (
    <Switch>
      <Route exact path="/" component={Landing} />
      <Route exact path="/signup" component={SignUp} />
      <Route exact path="/forgot-password" component={ForgotPassword} />
      <Route
        exact
        path="/forgot-password-expired"
        component={ExpiredForgotPassword}
      />
      <Route path="/logout">
        <Redirect to="/" />
      </Route>
      <Route component={PageNotFound} />
    </Switch>
  );
}

Public.propTypes = {};

export default Public;
